import React from "react";
import { motion } from "framer-motion";
import { Home, Search, Handshake, TrendingUp } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const steps = [
  {
    icon: Home,
    title: "Share Your Property",
    description:
      "Enter your address above and tell us a bit about your land. It takes less than two minutes.",
  },
  {
    icon: Search,
    title: "We Evaluate Your Land",
    description:
      "Our team reviews comparable sales, zoning, and buyer demand to understand what your property is really worth.",
  },
  {
    icon: Handshake,
    title: "We Structure A Fair Partnership",
    description:
      "We propose a joint venture agreement with a clear profit split — no listing fees, no upfront cost to you.",
  },
  {
    icon: TrendingUp,
    title: "We Sell, You Profit",
    description:
      "We market, finance, and close the sale. You collect your share of the profits once it sells.",
  },
];

const JVHowItWorks = () => (
  <section className="bg-[#F5F3EF] py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="mb-10 text-center sm:mb-14">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#C1694F] sm:text-sm">
          How It Works
        </p>
        <h2 className="mt-2 text-2xl font-bold text-[#16213E] sm:text-4xl">
          A Simple, No-Cost Path To A Sale
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
        {steps.map((step, index) => (
          <motion.div
            key={step.title}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeUp}
            className="relative rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 sm:p-8"
          >
            <span className="absolute -top-4 left-6 flex h-8 w-8 items-center justify-center rounded-full bg-[#16213E] text-sm font-bold text-white">
              {index + 1}
            </span>
            <step.icon className="mb-4 h-9 w-9 text-[#C1694F]" strokeWidth={1.75} />
            <h3 className="mb-2 text-lg font-semibold text-[#16213E]">{step.title}</h3>
            <p className="text-sm leading-relaxed text-slate-600">{step.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default JVHowItWorks;
